import { PayloadAction } from '@reduxjs/toolkit'
import axios from 'axios'
import { call, put, takeEvery } from 'redux-saga/effects'
import { getPortalUsers } from 'Modules/Communication/PortalUsers/shared/api/portalUsers.api'
import {
  IPortalUserFilter,
  IPortalUserResponseModel,
} from 'Modules/Communication/PortalUsers/shared/models/PortalUsers'

import { portalUserRequest, portalUserSuccess, portalUserError } from '.'

function* fetchPortalUsers({
  payload,
}: PayloadAction<IPortalUserFilter, string>) {
  try {
    const response: { data: IPortalUserResponseModel } = yield call(
      getPortalUsers,
      payload
    )
    yield put(portalUserSuccess(response.data))
  } catch (e) {
    if (!axios.isCancel(e)) {
      console.log(e)
      yield put(portalUserError(e))
    }
  }
}

function* portalUsersSaga() {
  yield takeEvery(portalUserRequest.type, fetchPortalUsers)
}

export default portalUsersSaga
